// Referências externas
import React, { useState, useEffect } from 'react';
import { FiFilePlus, FiTrash2, FiHelpCircle, FiCheck, FiRewind, FiDownload } from 'react-icons/fi';
import { useHistory } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Referências internas
import { Header, Loading, DynamicLoading } from '../../common';
import api from '../../services/api';
import ModalNovaProposta from './form/ModalNovaProposta';
import ModalPadrao2 from '../../common/Modais/ModalPadrao2';

// Estilo
import './styles.css';

// Referências internas
const permissaoUsuario = require('../../services/permissaoUsuario');

export default function Proposals() {
    const history = useHistory();
    const [token, setToken] = useState({});

    const [tabelaVigente, setTabelaVigente] = useState([]);
    const [proposals, setProposals] = useState([]);
    const [customerModal, setCustomerModal] = useState(false);
    const [customers, setCustomers] = useState([]);
    const [done, setDone] = useState(true);
    const [doneDeletar, setDoneDeletar] = useState(true);
    const [listaClientesCarregando, setListaClientesCarregando] = useState(true);

    const [buscaListaPropostas, setBuscaListaPropostas] = useState('');
    const [modalBuscaClienteAberto, setModalBuscaClienteAberto] = useState(false);

    const [modalConfirmarExclusaoAberto, setModalConfirmarExclusaoAberto] = useState(false);
    const [propostaExclusao, setPropostaExclusao] = useState({});

    const [listaAgente, setListaAgente] = useState([]);
    const [filtroAgente, setFiltroAgente] = useState("0");

    async function obterPropostaCompleta(propostaSelecionadaResumida) {
        const numero_proposta = propostaSelecionadaResumida.numero_proposta;
        const revisao_proposta = propostaSelecionadaResumida.revisao_proposta;

        const response = await api.get(`propostas/${numero_proposta}/${revisao_proposta}`);
        const propostaCompleta = response.data;

        return propostaCompleta[0];
    }

    function vocativo(proposta) {
        if(proposta.titulo_cliente !== "N/A") {
            return proposta.titulo_cliente + " " + proposta.nome_razao_cliente;

        } else {
            return proposta.nome_razao_cliente;
        }
    }

    function normalizar_texto(texto) {
        texto = texto.toString();
        texto = texto.toLowerCase();
        texto = texto.replace(new RegExp('[ÁÀÂÃ]','gi'), 'a');
        texto = texto.replace(new RegExp('[ÉÈÊ]','gi'), 'e');
        texto = texto.replace(new RegExp('[ÍÌÎ]','gi'), 'i');
        texto = texto.replace(new RegExp('[ÓÒÔÕ]','gi'), 'o');
        texto = texto.replace(new RegExp('[ÚÙÛ]','gi'), 'u');
        texto = texto.replace(new RegExp('[Ç]','gi'), 'c');
        return texto;
    }
    
    const notificarErro = () => {
        toast.error('Erro ao estabelecer conexão com o servidor', {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }

    const notificarSucessoGenerico = () => {
        toast.success('Operação executada com sucesso!', {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }

    const notificarErroPersonalizado = (error) => {
        const mensagem_erro = (typeof error.response !== "undefined") ? error.response.data.error : "";

        toast.error(`Erro ao estabelecer conexão com o servidor ${mensagem_erro}`, {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }

    function openCustomerModal() {
        setListaClientesCarregando(true);
        api.get('clientes').then(response => {
            setCustomers(response.data);
            setListaClientesCarregando(false);
        })
        setCustomerModal(true);
    }

    function carregareA() {
        setListaClientesCarregando(true);
        api.get('clientes').then(response => {
            setCustomers(response.data);
            setListaClientesCarregando(false);
        })
        setCustomerModal(true);
    }

    function novaProposta(id) {
        history.push({
            pathname: `propostas_completas/simular`,
            origin: '/propostas_completas',
            data:  id
        })        
    }

    async function editarProposta(propostaSelecionadaResumida) {
        const propostaSelecionada = await obterPropostaCompleta(propostaSelecionadaResumida);
        
        const id = {
            ID_cliente: propostaSelecionada.ID_cliente,
            titulo_cliente: propostaSelecionada.titulo_cliente,
            nome_razao_cliente: propostaSelecionada.nome_razao_cliente
        }

        history.push({
            pathname: `propostas_completas/simular`,
            origin: '/propostas_completas',
            data:  id,
            proposal: propostaSelecionada
        })        
    }

    async function novaRevisao(propostaSelecionadaResumida) {
        const propostaSelecionada = await obterPropostaCompleta(propostaSelecionadaResumida);

        try {
            setDone(false);
    
            const send = {
                "numero_proposta_duplicada": propostaSelecionada.numero_proposta,
                "revisao_proposta_duplicada": propostaSelecionada.revisao_proposta
            }
            const response = await api.post('propostas/duplicar', send);
            const propostaRevisada = response.data;
    
            const id = {
                ID_cliente: propostaRevisada.ID_cliente,
                titulo_cliente: propostaRevisada.titulo_cliente,
                nome_razao_cliente: propostaRevisada.nome_razao_cliente
            }
    
            history.push({
                pathname: `propostas_completas/simular`,
                origin: '/propostas_completas',
                data: id,
                proposal: propostaRevisada
            })
    
            setDone(true);
        } catch (error) {
            notificarErroPersonalizado(error.response.data.error);
            setDone(true);
        }   
    }

    async function deletarProposta(propostaExclusaoResumida) {
        setDoneDeletar(false);

        const propostaExclusao = await obterPropostaCompleta(propostaExclusaoResumida);
        
        try {
            await api.delete(`propostas/${propostaExclusao.numero_proposta}/${propostaExclusao.revisao_proposta}/1`);
            setProposals(proposals.filter(proposal => (
                proposal.numero_proposta !== propostaExclusao.numero_proposta ||
                proposal.revisao_proposta !== propostaExclusao.revisao_proposta
            )));

        } catch (error) {
            notificarErro();
        }

        setDoneDeletar(true);
    }    
    
    async function exportarPropostasCSV() {
        function gerarNomeArquivoCSVLocal() {
            const agora = new Date();

            const doisDigitos = (num) => String(num).padStart(2, '0');

            const ano = agora.getFullYear();
            const mes = doisDigitos(agora.getMonth() + 1);
            const dia = doisDigitos(agora.getDate());

            const hora = doisDigitos(agora.getHours());
            const minuto = doisDigitos(agora.getMinutes());
            const segundo = doisDigitos(agora.getSeconds());

            return `proposta_${ano}-${mes}-${dia}_${hora}-${minuto}-${segundo}.csv`;
        }

        try {

            const response = await api.get('propostas/exportar-propostas-csv', {
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', gerarNomeArquivoCSVLocal());
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            notificarSucessoGenerico();

        } catch (error) {
            notificarErroPersonalizado(error);
            console.log('Erro: exportarPropostasCSV');
        }
    }

    useEffect(() => {
        document.title = `SGC Brazil Solution`;
        setToken(JSON.parse(localStorage.getItem('sgc_br')));

        async function solicitarPropostasEClientes() {
            setDone(false);
            try {
                const responseDados = await api.get('dados')
                setTabelaVigente(responseDados.data.tabela_vigente.chave);
                setListaAgente(responseDados.data.responsaveis);

                const response = await api.get('propostas', {
                    timeout: 15000
                });

                setProposals(response.data);
                
            } catch (error) {
                notificarErro();
            }
            setDone(true);

            
            setListaClientesCarregando(true);
            try {
                const response = await api.get('clientes')
                setCustomers(response.data);
            } catch (error) {
                notificarErro();
            }
            setListaClientesCarregando(false);
        }

        solicitarPropostasEClientes();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="container">
            <Header />
            <ToastContainer />
            {modalConfirmarExclusaoAberto &&
                <ModalPadrao2
                    titulo = {"ATENÇÃO!"}
                    mensagem1 = {"A exclusão da proposta é irreversível!"}
                    parametro1 = {{"nome": "Nº da proposta:", "valor": propostaExclusao.numero_proposta}}
                    parametro2 = {{"nome": "Revisão da proposta:", "valor": propostaExclusao.revisao_proposta}}
                    parametro3 = {{"nome": "Agente Comercial:", "valor": propostaExclusao.nome_usuario}}
                    parametro4 = {{"nome": "Criador Proposta:", "valor": propostaExclusao.nome_usuario_criador}}
                    parametro5 = {{"nome": "Cliente:", "valor": vocativo(propostaExclusao)}}
                    parametro6 = {{"nome": "Valor:", "valor": Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(propostaExclusao.valor_final)}}
                    parametro7 = {{"nome": "Data:", "valor": (new Date(propostaExclusao.data_apresentacao_proposta)).toLocaleDateString()}}
                    mensagemConfirmar = {"Deseja prosseguir com a exclusão da proposta?"}
                    fecharModal = {() => setModalConfirmarExclusaoAberto(false)}
                    acaoModal = {() => {deletarProposta(propostaExclusao); setModalConfirmarExclusaoAberto(false);}}
                    confirmar = {"Excluir"}
                />
            }
            {/* <Modal
                isOpen={customerModal}
                onRequestClose={() => setCustomerModal(false)}
                style={{
                    content: {
                        top: '18%',
                        left: '28%',
                        right: '28%',
                        bottom: '18%',
                    }
                }}
            >
                <div className="modal-header">
                    <h2>Selecione um cliente</h2>
                    <button onClick={() => setCustomerModal(false)}>Cancelar</button>
                </div>

                <div className="modal-body">
                    {listaClientesCarregando ? (
                        <div>
                            <Loading />
                        </div>
                    )  :  (




                        <table className="select-customer">
                            <thead>
                                <tr>
                                    <th> Nome Completo / Razão Social </th>
                                    <th></th>
                                </tr>
                            </thead>

                            <tbody>
                                {customers.map(customer => (
                                    <tr key={customer.ID_cliente}>
                                        <td>{customer.nome_razao_cliente}</td>
                                        <td>
                                            <button onClick={() => novaProposta(customer)}>
                                                Selecionar cliente
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>



                    )}
                </div>

            </Modal> */}

            <div className="body-container-2">
                <div className="type1-element">
                    <div className="type1-top-line">
                        <div className="type1-title">
                            <div>Propostas</div>
                        </div>

                        <div className="text-input-search-wraper">
                            <input
                                autoFocus
                                name="busca_lista_proposta"
                                className="text-input-search"
                                type="text"
                                id="busca_lista_proposta"
                                placeholder="Pesquisar"
                                onChange={e => { setBuscaListaPropostas(e.target.value); }}
                                autoComplete="off"
                            />
                            
                            <div className="icone-ajuda">
                                <FiHelpCircle size={18}/>
                            </div>

                            <div className="esconder-ajuda">
                                É possível buscar por número de proposta e nome do cliente
                            </div>
                        </div>

                        { modalBuscaClienteAberto && <ModalNovaProposta listaClientesCarregando={listaClientesCarregando} clientes={customers} fechar={() => setModalBuscaClienteAberto(false)} novaProposta={novaProposta} normalizar_texto={normalizar_texto} /> }

                        <button className="type1-main-button"  onClick={() => setModalBuscaClienteAberto(true)} >
                            <FiFilePlus/>
                            <span>Nova proposta</span>
                        </button>

                        <button style={{marginLeft: "15px"}} className="type1-main-button" onClick={() => {exportarPropostasCSV()}} >
                            <FiDownload/>
                            <span>Exportar Propostas</span>
                        </button>
                    </div>
                    <div className="type3-content">



                    {!done ? (
                                <div>
                                    <Loading />
                                </div>
                            )  :  (
                                

                        <table className="proposals-table">
                        <thead>
                            <tr>
                                <th>Nº</th>
                                <th>Revisão</th>
                                <th>Cliente</th>
                                <th>Data</th>
                                <th>Valor</th>
                                <th>Sistema</th>
                                <th>
                                    <select onChange={e => {setFiltroAgente(e.target.value)}} name="select_agente_comercial">
                                        <option value="0">Todos</option>
                                        {listaAgente.map(x => {
                                            return (
                                                <option key={x.id_usuario} value={x.id_usuario}>{x.nome_usuario}</option>
                                            )
                                        })}
                                    </select>

                                </th>
                                <th>Criador Proposta</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            {proposals
                                .filter(proposal => {
                                    if (filtroAgente === "0") {
                                        return proposal.nome_razao_cliente;
                                    } else if (filtroAgente === String(proposal.id_usuario)) {
                                        return proposal.nome_razao_cliente;
                                    }
                                })
                                .filter(proposal => {
                                    if (buscaListaPropostas.length > 0 && buscaListaPropostas.replace(new RegExp('[0-9]','gi'), '') === '') {
                                        const proposta_atual_normalizada = normalizar_texto(proposal.numero_proposta);
                                        const proposta_desejada_normalizada = normalizar_texto(buscaListaPropostas);

                                        if (proposta_atual_normalizada.includes(proposta_desejada_normalizada)) {
                                            return proposal.nome_razao_cliente;
                                        }
                                    } else {
                                        const cliente_atual_normalizado = normalizar_texto(proposal.nome_razao_cliente);
                                        const cliente_desejado_normalizado = normalizar_texto(buscaListaPropostas);

                                        if (cliente_atual_normalizado.includes(cliente_desejado_normalizado)) {
                                            return proposal.nome_razao_cliente;
                                        }
                                    }
                                })
                                .map(proposal => {
                                    // let dateMysql = proposal.data_apresentacao_proposta.split(/[-T:.Z]/);
                                    let data_apresentacao_proposta = (new Date(proposal.data_apresentacao_proposta)).toLocaleDateString();

                                    return (
                                        <tr key={String(proposal.numero_proposta)+' '+String(proposal.revisao_proposta)}>
                                            <td>{proposal.numero_proposta}</td>

                                            <td className="icone-desatualizado">
                                                <span> {proposal.revisao_proposta} </span>

                                                {
                                                    (
                                                        tabelaVigente !== undefined
                                                        && proposal.tabela_considerada !== undefined
                                                        && proposal.tabela_considerada === tabelaVigente
                                                    ) ? (
                                                        <>
                                                             <div className="icone-ajuda-desatualizado">
                                                                <FiCheck color={'#2AAC2F'} size={18}/> 
                                                            </div>
                                                        
                                                            {/* <div className="esconder-ajuda-desatualizado">
                                                                Proposta atualizada
                                                            </div> */}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="icone-ajuda-desatualizado">
                                                                <FiRewind color={'#E9190F'} size={18}/> 
                                                            </div>
                                                        
                                                            {/* <div className="esconder-ajuda-desatualizado">
                                                                Proposta DESATUALIZADA
                                                            </div> */}
                                                        </>
                                                    )}
                                            </td>

                                            <td>{vocativo(proposal)}</td>
                                            <td>{data_apresentacao_proposta}</td>
                                            <td>{Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(proposal.valor_final)}</td>                                    
                                            <td>{proposal.sistema_sugerido.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 4})} kWp</td>
                                            <td>{proposal.nome_usuario}</td>
                                            <td>{proposal.nome_usuario_criador}</td>

                                            <td>
                                                <div className="type4-functions">
                                                    <button className="view-button1 botao-pagina-proposta" onClick={() => editarProposta(proposal)}>
                                                        Editar
                                                    </button>

                                                    <button className="view-button2 botao-pagina-proposta" onClick={() => novaRevisao(proposal)}>
                                                        Nova revisão
                                                    </button>

                                                    {!permissaoUsuario.verificar(60, token.tipo_usuario) ? (
                                                        <></>
                                                    ) : !doneDeletar ? (
                                                        <button className="white-background botao-pagina-proposta">
                                                            <DynamicLoading />
                                                        </button>
                                                    )  :  (
                                                        <button className="delete1 botao-pagina-proposta" onClick={() => {
                                                            setPropostaExclusao(proposal);
                                                            setModalConfirmarExclusaoAberto(true);
                                                        }}>
                                                            <FiTrash2 size={18} />
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                }
                            )}
                        </tbody>

                    </table>
                
                            ) }


                    </div>
                </div>
            </div>
        </div>
        
    );
}